module.exports = __webpack_public_path__ + "img/sec18desk.8c34b4c1.png";